var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRupeeGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.135,
    r: 8.333,
    fill: "#0EA546"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.802h5m-4.167 0a2.5 2.5 0 110 5H7.5l2.5 2.5m-2.5-5h5",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgRupeeGreen;